import { AgGridReact } from 'ag-grid-react'
import { Card, CardBody } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react'
import CreateJobScreening from './CreateJobScreening'
import { useDispatch } from 'react-redux'
import { getJobScreenings } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteJobScreening } from 'store/Recruitment/actions'
import { setFormSubmitted } from 'store/Recruitment/actions'

function JobScreening() {
  const dispatch = useDispatch()

  const { jobScreenings } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState(false)
  const [jobScreening, setJobScreening] = useState(null)

  const columns = [
    {
      headerName: 'Question',
      resizable: true,
      field: 'question',
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Is Required?',
      field: 'is_required',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center h-100'>
          <span
            className={`badge px-3 py-2 ${
              params.value ? 'bg-success' : 'bg-danger'
            } text-white`}
          >
            {params.value ? 'Yes' : 'No'}
          </span>
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              setJobScreening(params.data)
              setShowModal(true)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () => dispatch(deleteJobScreening(params.data.id)),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  useEffect(() => {
    dispatch(getJobScreenings())
  }, [dispatch])

  useEffect(() => {
    if (!showModal) {
      setJobScreening(null)
      dispatch(setFormSubmitted(false))
    }
  }, [showModal, dispatch])

  return (
    <>
      <Card
        onClick={() => setShowModal(true)}
        className='bg-info text-white plus-button'
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>
      <Card>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact columnDefs={columns} rowData={jobScreenings} />
          </div>
        </CardBody>
      </Card>
      {showModal && (
        <CreateJobScreening
          showModal={showModal}
          setShowModal={setShowModal}
          jobScreening={jobScreening}
        />
      )}
    </>
  )
}

export default JobScreening
